import { get } from 'lodash';
import { useFormContext } from 'react-hook-form';
import StyledInput, { StyledInputProps } from '~/components/ui/Form/StyledInput';

interface FormularTextInputProps extends Omit<StyledInputProps, 'isInvalid' | 'name'> {
    name: string;
}

const FormularTextInput = ({ name, helperText, ...props }: FormularTextInputProps) => {
    const {
        register,
        formState: { errors }
    } = useFormContext();
    const error = get(errors, name);
    const { ref, ...registerProps } = register(name);

    return (
        <StyledInput
            {...registerProps}
            ref={ref}
            name={name}
            isInvalid={!!error}
            helperText={(error?.message as string) || helperText}
            fullWidth
            {...props}
        />
    );
};

export default FormularTextInput;
